// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import './assets/styles/style.css';

let app;

// Listen for auth state changes before creating the app
onAuthStateChanged(auth, (user) => {
  if (!app) {
    app = createApp(App);
    app.use(router);
    app.mount('#app');
  }

  if (user) {
    // console.log('User is signed in:', user);
    // You can perform additional setup here if needed
  } else {
    // console.log('No user is signed in.');
    // Handle the case where no user is signed in if necessary
  }
});